import { zodResolver } from '@hookform/resolvers/zod';
import { useEffect, useMemo } from 'react';
import { useForm } from 'react-hook-form';
import { useBudgetId } from '../../budget/budget-store';
import { useMoveAssignmentApi } from '../../budget/api/use-move-assignment';
import { z } from 'zod';
const assignmentRequestMoveSchema = z.object({
    budgetId: z.string().uuid(),
    sourceId: z.string().or(z.null()),
    targetId: z.string().or(z.null()),
    month: z.coerce.number().min(1).max(12),
    year: z.coerce.number().min(1).max(9999),
    amount: z.coerce.number(),
});
export const useMoveAssignmentForm = (year, month, amount, sourceId, targetId, onSuccess) => {
    const budgetId = useBudgetId();
    const { mutate, isPending } = useMoveAssignmentApi({ onSuccess });
    const defaultValues = useMemo(() => ({
        budgetId,
        sourceId,
        targetId,
        year,
        month,
        amount,
    }), [budgetId, sourceId, targetId, year, month, amount]);
    const form = useForm({
        resolver: zodResolver(assignmentRequestMoveSchema),
        defaultValues,
    });
    useEffect(() => {
        form.reset(defaultValues);
    }, [defaultValues, form]);
    const handleSubmit = (values) => {
        mutate({
            ...values,
            targetId: values.targetId === 'inflow' ? null : values.targetId,
        }).then(() => { });
    };
    return {
        form,
        onSubmit: form.handleSubmit(handleSubmit),
        isSubmitting: isPending,
    };
};
